// import React, { useEffect, useState } from "react";
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import Header from "./gapsy-header";
import Navigation from "./gapsy-Cnavigation";
import Footer from "./gapsy-footer";
import styles from "../assets/css/gapsy-dashboard.module.css";
import tableStyles from "../assets/css/sharedTableStyles.module.css";
import { uploadMutiple, getcomplaintsconfig, shariahremarks, Bulkuploaddata, checkboxapprove, checkboxreject, previewrdmdata, shariahadminmapping, operationalvalue, updatetextfile3001 } from '../components/ApiProperty';
import { Modal, Button, Form } from 'react-bootstrap';
import { Aprrovecolor, Rejectcolor, submitButtonStyle, cancelButtonStyle, ProceedButtonStyle, UploadLoadingIcon } from "../components/Propertyfile";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import GapsyShariahDescription from "../components/GapsyShariahDescription";


const GapsyReportReview = () => {
    const [sheetData, setSheetData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [indexRows, setIndexRows] = useState([]);
    const [messageType, setMessageType] = useState(''); // 'success' or 'error'
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showNotifyModal, setShowNotifyModal] = useState(false);
    const [makerRemarks, setMakerRemarks] = useState("");
    // const [showReportingModal, setShowReportingModal] = useState(false);
    const [isViewMode, setIsViewMode] = useState(false);

    const [tempData, setTempData] = useState([]);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [selectedColumn, setSelectedColumn] = useState("");
    const [otherReason, setOtherReason] = useState("");
    const [showConfirmApprove, setShowConfirmApprove] = useState(false);
    const [rejectedReason, setRejectedReason] = useState("");
    const [showDownload, setShowDownload] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);

    const [liveData, setLiveData] = useState([]);
    const [showReportingModal1, setShowReportingModal1] = useState(false);
    const [reportingMessage, setReportingMessage] = useState("");
    const [allowSubmit, setAllowSubmit] = useState(true);
    const [inputValue, setInputValue] = useState("");
    const [showmakerRemarks, SetshowMakerremarks] = useState(false);
    const [q1, setQ1] = useState("");
    const [q2, setQ2] = useState("");
    const [q3, setQ3] = useState("");
    const [reportingDate, setReportingDate] = useState("");
    let csrfToken = sessionStorage.getItem("tokenizedSession");
    const userId = localStorage.getItem("userid");
    const department = sessionStorage.getItem("dept");
    const [weightError, setWeightError] = useState("");
    const [gradeRows, setGradeRows] = useState([]);
    const [initialIndexRows, setInitialIndexRows] = useState([]);
    const [modifiedOn, setModifiedOn] = useState("");
    const [excelRows, setExcelRows] = useState([]);
    const [initialGradeRows, setInitialGradeRows] = useState([]);
    const [availableReportingDates, setAvailableReportingDates] = useState([]);
    const [operationalRiskCharge, setOperationalRiskCharge] = useState(0);
    const [showReportingModal, setShowReportingModal] = useState(false);
    const [showChargeModal, setShowChargeModal] = useState(false);
    const [showActionButtons, setShowActionButtons] = useState(true);
    const [statusData, setStatusData] = useState([]);
    const [selectedReportingDate1, setselectedReportingDate1] = useState([]);
    const [selectedReportingDate, setSelectedReportingDate] = useState([]);
    const [reportingDates1, setReportingDates1] = useState([]);
    const [capitalChargeData, setCapitalChargeData] = useState([]);
    const [adminMappingData, setAdminMappingData] = useState([]);
    const [excelMerges, setExcelMerges] = useState([]);
    const [editingExcelRows, setEditingExcelRows] = useState({});
    const [editingAverageRows, setEditingAverageRows] = useState({});
    const [newAverageRows, setNewAverageRows] = useState([]);
    const [newComplaintSections, setNewComplaintSections] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");
    const [complaintApiData, setComplaintApiData] = useState([]);
    const [scoreTemplateRows, setScoreTemplateRows] = useState([]);
    const [scoreTemplateMerges, setScoreTemplateMerges] = useState([]);
    const [parameterScores, setParameterScores] = useState({});
    const [availableScores, setAvailableScores] = useState([]);




    const leftTableRef = useRef(null);
    const [groupHeights, setGroupHeights] = useState({});
    const [theadHeight, setTheadHeight] = useState(null);
    const [savedRatingColors] = useState(() => {
            try {
                return JSON.parse(
                    localStorage.getItem("ratingColors") || "[]"
                );
            } catch {
                return [];
            }
        });

    const measureLeftTable = () => {
        const table = leftTableRef.current;
        if (!table) return;

        const next = {};
        table.querySelectorAll("tbody tr[data-group-key]").forEach((tr) => {
            const key = tr.getAttribute("data-group-key");
            next[key] = (next[key] || 0) + tr.getBoundingClientRect().height;
        });

        setGroupHeights((prev) =>
            JSON.stringify(prev) === JSON.stringify(next) ? prev : next
        );

        const thead = table.querySelector("thead");
        const h = thead ? thead.getBoundingClientRect().height : null;
        setTheadHeight((prev) => (prev === h ? prev : h));
    };

    useLayoutEffect(() => {
        measureLeftTable();

        const table = leftTableRef.current;
        if (!table || typeof ResizeObserver === "undefined") return;

        const observer = new ResizeObserver(measureLeftTable);
        observer.observe(table);
        return () => observer.disconnect();
    }, [complaintApiData, excelRows, loading]);

    // Parse a range text like "1 - 2", "1.0 to 2.4", "< 2", ">= 4", "4+" or "3"
    const parseScoreRange = (text) => {
        const s = String(text ?? "").toLowerCase().replace(/,/g, "").trim();
        const nums = (s.match(/\d+(?:\.\d+)?/g) || []).map(Number);

        if (nums.length === 0) return null;

        const hasEqual = s.includes("=");

        if (nums.length === 1) {
            if (s.includes("<") || s.includes("less") || s.includes("below")) {
                return { min: -Infinity, max: nums[0], minInc: true, maxInc: hasEqual };
            }
            if (s.includes(">") || s.includes("+") || s.includes("above") || s.includes("more")) {
                return { min: nums[0], max: Infinity, minInc: hasEqual || !s.includes(">"), maxInc: true };
            }
            return { min: nums[0], max: nums[0], minInc: true, maxInc: true };
        }

        return {
            min: Math.min(nums[0], nums[1]),
            max: Math.max(nums[0], nums[1]),
            minInc: true,
            maxInc: true,
        };
    };

    // Returns { item, index } of the matching Rating row, or null
    const getRatingForAverage = (avg) => {
        const value = Number(avg);
        if (!Number.isFinite(value)) return null;

        const ranges = averageScoreRows.map((item, index) => ({
            item,
            index,
            range: parseScoreRange(item.averageScore) || parseScoreRange(item.section),
        }));

        // 1. Exact match inside a range
        const exact = ranges.find(({ range }) => {
            if (!range) return false;
            const aboveMin = range.minInc ? value >= range.min : value > range.min;
            const belowMax = range.maxInc ? value <= range.max : value < range.max;
            return aboveMin && belowMax;
        });
        if (exact) return exact;

        // 2. Gaps like 1.0-1.9 / 2.0-2.9 with average 1.95: use the closest lower range
        const lower = ranges
            .filter(({ range }) => range && range.min <= value)
            .sort((a, b) => b.range.min - a.range.min);

        return lower[0] || null;
    };

    const RATING_COLORS_BY_INDEX = [
        "#00B050", // First existing rating: Red
        "#FFC000", // Second existing rating: Yellow
        "#FF0000", // Third existing rating: Red
    ];

    const NEW_RATING_COLOR = "#A6A6A6"; // Every newly added rating



    useEffect(() => { loadExcel(); }, []);

    const fmt = (val) => {
        if (val === null || val === undefined || val === "") return "-";
        if (typeof val === "number") {
            if (val > 0 && val < 1) return (val * 100).toFixed(0) + "%";
            return val.toLocaleString("en-US", { maximumFractionDigits: 2 });
        }
        return String(val);
    };

    useEffect(() => {
        fetchPreviewData();
    }, []);

    useEffect(() => {
        operational();
    }, []);


    const populateParameterScores = (tempRows, reportDate) => {
        console.log("Selected reporting date:", reportDate);
        console.log("All temp rows:", tempRows);

        const matchingRows = tempRows
            .filter(
                (row) =>
                    String(row.reporting_date ?? "").trim() ===
                    String(reportDate ?? "").trim() &&
                    String(row.active_yn ?? "").trim().toUpperCase() === "Y"
            )
            .sort((a, b) => Number(a.rowId) - Number(b.rowId));

        console.log("Matching temp rows:", matchingRows);

        const groupedParameters = new Map();

        complaintApiData.forEach((item) => {
            const key = JSON.stringify([
                item.CUSTOMER_TYPE ?? "",
                item.SR_NO ?? "",
                item.PARAMETERS ?? "",
            ]);

            if (!groupedParameters.has(key)) {
                groupedParameters.set(key, key);
            }
        });

        const parameterKeys = Array.from(groupedParameters.keys());

        console.log("Parameter keys:", parameterKeys.length);
        console.log("Matching rows count:", matchingRows.length);

        const populatedScores = {};

        parameterKeys.forEach((key, index) => {
            const row = matchingRows[index];

            if (row) {
                populatedScores[key] = {
                    score: String(row.score ?? ""),
                    description: String(
                        row.actual_value_or_description ?? ""
                    ),
                };
            }
        });

        console.log("Populated parameter scores:", populatedScores);

        setParameterScores(populatedScores);
    };


    const loadReportingDateData = async (quarter) => {
        if (!quarter) {
            handleReset();
            setMakerRemarks("");
            setIsEditMode(true);
            setIsViewMode(false);
            return;
        }

        const reportDate = getReportingDate(quarter);

        // Get all TEMP records for the selected reporting date.
        const records = tempData.filter(
            (row) =>
                String(row.reporting_date ?? "").trim() ===
                String(reportDate ?? "").trim()
        );

        console.log("TEMP RECORDS:", records);

        // Find Maker Remarks across the reporting date's records.
        const makerRemarks =
            records.find(
                (row) => !isNullValue(row.Maker_Remarks)
            )?.Maker_Remarks || "";

        // Fall back to submitted remarks if TEMP remarks are unavailable.
        const submittedRemarks =
            statusData.find(
                (item) =>
                    String(item.reporting_date ?? "").trim() ===
                    String(reportDate ?? "").trim()
            )?.submitted_remarks || "";

        // Reset other form fields first.
        handleReset();

        // Restore remarks after reset.
        setMakerRemarks(
            !isNullValue(makerRemarks)
                ? makerRemarks
                : submittedRemarks
        );

        setIsViewMode(records.length > 0);
    };

    useEffect(() => {

        if (reportingDate) {
            loadReportingDateData(reportingDate);
        }

    }, [reportingDate]);

    const fetchTableData = async (tableName) => {

        const config = {
            headers: {
                userId: localStorage.getItem("userid"),
                "x-csrf-token": csrfToken,
            },
            withCredentials: true,
            params: {
                tableName,
                dataModel: "DEM",
            },
        };

        // Get JSON filename
        const apiResponse = await axios.post(previewrdmdata, {}, config);

        if (!apiResponse.data?.fileName) {
            throw new Error(`No data file available for ${tableName}`);
        }

        const fetchedFileName = apiResponse.data.fileName;

        // Fetch JSON
        const dataResponse = await fetch(`/jsonfiles/${fetchedFileName}`);

        if (!dataResponse.ok) {
            throw new Error(`Failed to load ${fetchedFileName}`);
        }

        const jsonData = await dataResponse.json();

        return {
            fileName: fetchedFileName,
            data: jsonData
        };
    };

    useEffect(() => {
        fetchStatusData();
    }, []);

    const fetchStatusData = async () => {
        const tableNameWithJson = "10192_reputational.json";

        try {
            const response = await fetch(`/jsonfiles/${tableNameWithJson}`);

            if (response.ok) {
                const data = await response.json();
                setStatusData(data);
            } else {
                setStatusData([]);
            }
        } catch (err) {
            console.log("No existing status file. Creating new one.");
            setStatusData([]);
        }
    };

    const sortQuarter = (a, b) => {

        const [qa, ya] = a.split("-");
        const [qb, yb] = b.split("-");

        const yearA = Number(ya);
        const yearB = Number(yb);

        if (yearA !== yearB) {
            return yearA - yearB;
        }

        return Number(qa.replace("Q", "")) - Number(qb.replace("Q", ""));
    };

    const rawExcelTitle = localStorage.getItem("excelTitle")?.trim() || "";

    const excelTitle = rawExcelTitle
        ? rawExcelTitle.charAt(0).toUpperCase() + rawExcelTitle.slice(1)
        : "";

    const fetchPreviewData = async (openReportingModal = true) => {
        try {
            const [tempResult, liveResult] = await Promise.all([
                fetchTableData("Risk_reputational_thresholds_temp"),
                fetchTableData("Risk_reputational_thresholds_live"),
            ]);

            setTempData(tempResult.data);
            setLiveData(liveResult.data);

            loadNextReportingDate(
                tempResult.data,
                liveResult.data
            );

            // Merge both tables
            const allRows = [
                ...tempResult.data,
                ...liveResult.data,
            ];

            // Unique reporting dates
            const uniqueQuarters = [
                ...new Set(
                    allRows
                        .map(item => item.reporting_date)
                        .filter(date => date)
                        .map(date => getQuarterFromDate(date))
                ),
            ].sort(sortQuarter);

            console.log("All unique quarters:", uniqueQuarters);

            const latestThreeReportingDates =
                uniqueQuarters.slice(-3);

            console.log(
                "Latest 3 reporting dates:",
                latestThreeReportingDates
            );

            setReportingDates1(latestThreeReportingDates);

            if (latestThreeReportingDates.length > 0) {
                setselectedReportingDate1([]);
                setCapitalChargeData([]);
            }

            // Determine the reporting date to use
            const storedDate = localStorage.getItem(
                "selectedReportingDate"
            );

            let selectedDate = storedDate || "";

            if (storedDate) {
                const quarter = reportingDates.find(
                    item => getReportingDate(item) === storedDate
                );

                if (quarter) {
                    setReportingDate(quarter);
                    setShowDownload(false);
                    setAllowSubmit(false);
                    selectedDate = getReportingDate(quarter);
                }

                localStorage.removeItem("selectedReportingDate");
            }

            // If no stored date exists, calculate the next reporting date.
            if (!selectedDate) {
                const usedDates = new Set(
                    allRows
                        .map(row => row.reporting_date)
                        .filter(Boolean)
                );

                const nextQuarter = reportingDates.find(
                    item => !usedDates.has(getReportingDate(item))
                );

                if (nextQuarter) {
                    selectedDate = getReportingDate(nextQuarter);
                    setReportingDate(nextQuarter);
                }
            }

            // Populate scores and descriptions for the selected reporting date.
            // if (selectedDate) {
            //     populateParameterScores(
            //         tempResult.data,
            //         selectedDate
            //     );
            // } else {
            //     setParameterScores({});
            // }

        } catch (err) {
            console.error("Preview Fetch Error:", err);
        }
    };

    const loadedReportingDateRef = useRef(null);

    // 1. Populate scores for the selected reporting date
    useEffect(() => {
        if (
            !reportingDate ||
            !tempData?.length ||
            !complaintApiData?.length
        ) {
            return;
        }

        populateParameterScores(tempData, reportingDate);
    }, [tempData, reportingDate, complaintApiData]);

    // 2. Load Excel/API data for the selected reporting date
    useEffect(() => {
        const currentDate =
            reportingDate || availableReportingDates?.[0];

        if (!currentDate) return;

        if (loadedReportingDateRef.current === currentDate) return;

        loadedReportingDateRef.current = currentDate;

        loadExcel();
    }, [reportingDate, availableReportingDates]);

    // useEffect(() => {
    //     if (availableReportingDates?.length > 0) {
    //         fetchShariahAdminModifyData();
    //     }
    // }, [availableReportingDates]);

    const parsePercentage = (value, fallback = 0) => {
        if (value === null || value === undefined || String(value).trim() === "") {
            return fallback;
        }

        const cleanedValue = String(value)
            .replace("%", "")
            .trim();

        const parsed = Number(cleanedValue);

        return Number.isFinite(parsed) ? parsed : fallback;
    };

    const mergeExcelWithAdminGradeData = (excelRows = [], apiRows = []) => {
        const normalize = (value) =>
            String(value ?? "")
                .trim()
                .toLowerCase();

        const excelMap = new Map(
            excelRows.map(row => [
                normalize(row.scoreGrade),
                row
            ])
        );

        return apiRows.map(apiRow => {
            const key = normalize(apiRow.SCORE_GRADE);
            const excelRow = excelMap.get(key) || {};

            const jsonPercentage = apiRow.PERCENTAGE_OF_OPERATIONAL_RISK_PILLAR_I_CAPITAL_CHARGE;

            // Convert JSON "15%" -> 0.15
            const percentage =
                jsonPercentage !== null &&
                    jsonPercentage !== undefined &&
                    String(jsonPercentage).trim() !== ""
                    ? Number(String(jsonPercentage).replace("%", "").trim()) / 100
                    : Number(excelRow.percentage) || 0;

            return {
                // Excel/default values
                ...excelRow,

                // JSON values override Excel
                scoreGrade: apiRow.SCORE_GRADE,
                min: Number(apiRow.MIN) || 0,
                max: Number(apiRow.MAX) || 0,

                // IMPORTANT:
                // Keep percentage internally as decimal
                // JSON "15%" -> 0.15
                percentage: percentage,

                // Calculated later
                applicablePercentage: 0,

                rowId: apiRow.ROW_ID,
                reportingDate: apiRow.REPORTING_DATE,
                activeYn: apiRow.ACTIVE_YN
            };
        });
    };

    const fetchShariahAdminModifyData = async () => {
        try {
            const currentQuarter = availableReportingDates?.[0];

            if (!currentQuarter) {
                return;
            }

            const config = {
                headers: {
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    userId: localStorage.getItem("userid"),
                    reportingDate: currentQuarter,
                    dept: department,
                },
            };

            const response = await axios.post(
                shariahadminmapping,
                {},
                config
            );

            if (response.data?.status === "NO_DATA") {
                console.log(
                    "No admin mapping found. Using Excel data only."
                );

                setAdminMappingData([]);
                return response.data;
            }

            if (response.data?.status !== "SUCCESS") {
                throw new Error(
                    response.data?.message ||
                    "Failed to fetch Shariah mapping details."
                );
            }
            console.log("Requested Reporting Date:", reportDate);
            console.log("API Reporting Date:", response.data.reportingDate);
            console.log("Admin mapping:", response.data);

            // FIRST: verify reporting date
            if (response.data?.reportingDate !== reportDate) {
                console.warn(
                    `Reporting date mismatch. Requested: ${reportDate}, API: ${response.data?.reportingDate}`
                );

                setAdminMappingData([]);
                return;
            }

            // Only matching reporting date is stored
            setAdminMappingData(response.data?.data || []);

            return response.data;

        } catch (error) {
            console.error(
                "Error fetching Shariah admin modify data:",
                error
            );
        }
    };

    const mergeExcelWithAdminData = (excelRows = [], apiRows = []) => {
        const normalize = (value) =>
            String(value ?? "")
                .trim()
                .toLowerCase();

        // Excel rows map
        const excelMap = new Map(
            excelRows.map(row => [
                normalize(row.keyArea),
                row
            ])
        );

        // JSON should be the MAIN source
        return apiRows.map(apiRow => {
            const key = normalize(apiRow.KEY_AREAS);
            const excelRow = excelMap.get(key) || {};

            return {
                // Excel/default fields
                ...excelRow,

                // JSON fields MUST override Excel
                keyArea: apiRow.KEY_AREAS,
                weight:
                    Number(
                        String(apiRow.WEIGHT_A ?? "")
                            .replace("%", "")
                            .trim()
                    ) / 100,

                observations: excelRow.observations ?? "",
                impact: excelRow.impact ?? "",
                index: excelRow.index ?? 0,

                rowId: apiRow.ROW_ID,
                reportingDate: apiRow.REPORTING_DATE,
                scoreGrade: apiRow.SCORE_GRADE,
                min: Number(apiRow.MIN) || 0,
                max: Number(apiRow.MAX) || 0,

                percentage: excelRow.percentage,

                activeYn: apiRow.ACTIVE_YN,

                createdBy: apiRow.CREATED_BY,
                createdDt: apiRow.CREATED_DT,
                validDttm: apiRow.VALID_DTTM
            };
        });
    };

    useEffect(() => {

        if (!adminMappingData?.length) {
            if (initialIndexRows?.length) {
                setIndexRows(initialIndexRows);
            }

            if (initialGradeRows?.length) {
                setGradeRows(initialGradeRows);
            }

            return;
        }
        const selectedDate = normalizeDate(
            getReportingDate(availableReportingDates[0])
        );

        const apiDate = normalizeDate(
            adminMappingData[0]?.REPORTING_DATE
        );

        console.log("Selected Reporting Date:", selectedDate);
        console.log("JSON Reporting Date:", apiDate);

        // Reporting date MUST match
        if (apiDate !== selectedDate) {
            console.warn(
                `Not merging. Selected date: ${selectedDate}, API date: ${apiDate}`
            );
            return;
        }

        // -----------------------------
        // INDEX TABLE
        // -----------------------------
        if (initialIndexRows?.length) {
            const mergedIndexRows = mergeExcelWithAdminData(
                initialIndexRows,
                adminMappingData
            );

            console.log("Final Index Rows:", mergedIndexRows);

            setIndexRows(mergedIndexRows);
        }

        // -----------------------------
        // GRADE TABLE
        // -----------------------------
        if (initialGradeRows?.length) {

            const gradeApiRows = adminMappingData.filter(
                row =>
                    row.SCORE_GRADE !== null &&
                    String(row.SCORE_GRADE).trim() !== ""
            );

            const mergedGradeRows = mergeExcelWithAdminGradeData(
                initialGradeRows,
                gradeApiRows
            );

            console.log("Final Grade Rows:", mergedGradeRows);

            setGradeRows(mergedGradeRows);
        }

    }, [
        initialIndexRows,
        initialGradeRows,
        adminMappingData,
        availableReportingDates
    ]);

    // const operational = async () => {
    //     try {
    //         const config = {
    //             headers: {
    //                 userId: localStorage.getItem("userid"),
    //                 "x-csrf-token": csrfToken,
    //             },
    //             withCredentials: true
    //         };

    //         const apiResponse = await axios.post(operationalvalue, {}, config);

    //         const response = apiResponse.data;

    //         console.log("operationalvalue", response);

    //         if (response.success) {
    //             setOperationalRiskCharge(response.value);
    //         }

    //     } catch (err) {
    //         console.error(err);
    //     }
    // };

    const operational = async () => {
        try {
            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true
            };

            const apiResponse = await axios.post(operationalvalue, {}, config);

            const response = apiResponse.data;

            console.log("operationalvalue", response);

            // Use ACTUAL_VALUE if available,
            // otherwise always use PREVIOUS_VALUE
            const value =
                response.ACTUAL_VALUE !== null &&
                    response.ACTUAL_VALUE !== undefined
                    ? response.ACTUAL_VALUE
                    : response.PREVIOUS_VALUE;

            if (value !== null && value !== undefined) {
                setOperationalRiskCharge(value);
            }

        } catch (err) {
            console.error(err);
        }
    };

    const str = (c) => (c == null ? "" : String(c).trim());

    const c1 = (row) => {
        if (!row || !Array.isArray(row)) return "";
        return str(row[1]);
    };


    const isNullValue = (value) => {
        if (value == null) return true;

        const v = String(value).trim().toUpperCase();

        return (
            v === "" ||
            v === "\\N" ||
            v === "N" ||
            v === "//N" ||
            v === "NULL"
        );
    };

    const loadNextReportingDate = (temp, live) => {
        const usedDates = new Set();

        [...temp, ...live].forEach((row) => {
            if (row.reporting_date) {
                usedDates.add(String(row.reporting_date).trim());
            }
        });

        // Preserve an already selected reporting date.
        if (reportingDate) {
            setAvailableReportingDates([reportingDate]);
            return;
        }

        // Otherwise, choose the first unused reporting date.
        const nextDate = reportingDates.find(
            (date) => !usedDates.has(getReportingDate(date))
        );

        setAvailableReportingDates(nextDate ? [nextDate] : []);

        if (nextDate) {
            setReportingDate(nextDate);
        }
    };

    const reportingDates = [
        "FY 2024",
        "FY 2025",
        "FY 2026",
        "FY 2027",
        "FY 2028",
        "FY 2029",
        "FY 2030"
    ];

    const getReportingDate = (year) => {
        return year || "";
    };

    const handleCancel = () => {
        restoreExcelValues();
        setShowModal(false);
        setShowReportingModal1(false);
        setShowChargeModal(false);
        setModalMessage("");
    };



    const loadExcel = async () => {
        try {
            setLoading(true);

            // 1. Load Excel only for table structure and headers
            const response = await fetch(
                "/templates/new_mapping.xlsx"
            );

            if (!response.ok) {
                throw new Error("Unable to load Excel template.");
            }

            const data = await response.arrayBuffer();

            const workbook = XLSX.read(data, {
                type: "array",
                cellStyles: true,
            });

            const sheetName = "Complaints Thresholds";
            const worksheet = workbook.Sheets[sheetName];

            if (!worksheet) {
                throw new Error(`${sheetName} sheet not found.`);
            }

            // Load the score sheet from the same workbook.
            const scoreSheetName = "FY 2026 Scores";
            const scoreWorksheet = workbook.Sheets[scoreSheetName];

            if (!scoreWorksheet) {
                throw new Error(`${scoreSheetName} sheet not found.`);
            }

            const scoreRows = XLSX.utils.sheet_to_json(scoreWorksheet, {
                header: 1,
                defval: "",
                raw: false,
            });

            setScoreTemplateRows(scoreRows);
            setScoreTemplateMerges(scoreWorksheet["!merges"] || []);

            // Extract numeric score values from column B.
            // Exclude the Average Score row.


            const templateRows = XLSX.utils.sheet_to_json(worksheet, {
                header: 1,
                defval: "",
                raw: false,
            });

            // Keep Excel structure for the existing headers/layout.
            setExcelRows(templateRows);
            setExcelMerges(worksheet["!merges"] || []);

            // 5. Reporting dates in chronological order
            const reportingDates = [
                "FY 2024",
                "FY 2025",
                "FY 2026",
                "FY 2027",
                "FY 2028",
                "FY 2029",
                "FY 2030",
            ];

            // Current reporting date displayed in the input
            const currentQuarter =
                reportingDate || availableReportingDates?.[0] || "";

            if (!currentQuarter) {
                setComplaintApiData([]);
                console.warn("Current reporting date is not available.");
                return;
            }

            const currentIndex = reportingDates.indexOf(currentQuarter);

            if (currentIndex === -1) {
                throw new Error(
                    `Invalid reporting date: ${currentQuarter}`
                );
            }

            console.log("Current reporting date:", currentQuarter);

            // 6. API configuration
            const config = {
                headers: {
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    userId: localStorage.getItem("userid"),
                    tableName: "reputational_thresholds",
                    dept: department,
                    templateName: "reputational_thresholds",
                },
            };

            // 7. Fetch complaints for one reporting date
            const fetchComplaints = async (date) => {
                console.log("Fetching complaints for:", date);

                const apiResponse = await axios.post(
                    getcomplaintsconfig,
                    {},
                    {
                        ...config,
                        params: {
                            ...config.params,
                            reportingDate: date,
                        },
                    }
                );

                const responseData = apiResponse.data;

                const status = String(
                    responseData?.status ?? ""
                ).trim().toUpperCase();

                const message = String(
                    responseData?.message ?? ""
                ).trim().toUpperCase();

                const apiData = Array.isArray(responseData?.data)
                    ? responseData.data
                    : [];

                // Data found
                if (status === "SUCCESS" && apiData.length > 0) {
                    return {
                        found: true,
                        data: apiData,
                    };
                }

                // Handle different possible No_data response formats
                const noData =
                    ["NO_DATA", "NO-DATA", "NODATA"].includes(status) ||
                    ["NO_DATA", "NO-DATA", "NODATA"].includes(message) ||
                    (
                        status === "SUCCESS" &&
                        apiData.length === 0
                    );

                if (noData) {
                    console.log(`No data available for ${date}.`);

                    return {
                        found: false,
                        data: [],
                    };
                }

                // Unexpected response: do not retry as if it were No_data
                throw new Error(
                    `API failed for ${date}: ${JSON.stringify(responseData)}`
                );
            };

            // 8. Retry from the current reporting date backwards
            let result = { found: false, data: [] };
            let foundReportingDate = null;

            for (let i = currentIndex; i >= 0; i--) {
                const dateToFetch = reportingDates[i];

                console.log(`Checking reporting date: ${dateToFetch}`);

                result = await fetchComplaints(dateToFetch);

                if (result.found) {
                    foundReportingDate = dateToFetch;

                    setComplaintApiData(result.data);

                    console.log(
                        `Complaints loaded successfully for ${foundReportingDate}.`
                    );

                    break;
                }

                console.log(`No data for ${dateToFetch}. Checking previous date...`);
            }

            // 9. No data found for any reporting date
            if (!foundReportingDate) {
            setComplaintApiData([]);

            console.log(
                    "No complaints data found for any available reporting date."
            );
            }

        } catch (error) {
            console.error("Error loading complaints data:", error);
            setComplaintApiData([]);
        } finally {
            setLoading(false);
        }
    };


    const normalizeDate = (date) => {
        if (!date) return "";

        return String(date)
            .trim()
            .substring(0, 10);
    };

    const restoreExcelValues = () => {
        setIndexRows(initialIndexRows.map(row => ({ ...row })));
        setGradeRows(initialGradeRows.map(row => ({ ...row })));
    };

    const handleIndexChange = (rowIndex, field, value) => {
        const updatedRows = [...indexRows];

        if (field === "impact") {
            // Allow empty while editing
            if (value === "") {
                updatedRows[rowIndex].impact = "";
            } else {
                // Only allow whole numbers
                if (!/^\d+$/.test(value)) return;

                const num = Number(value);

                // Allow only 1-10
                if (num < 1 || num > 10) return;

                updatedRows[rowIndex].impact = num;
            }
        } else {
            updatedRows[rowIndex][field] = value;
        }

        const weight = Number(updatedRows[rowIndex].weight) || 0;
        const observations = Number(updatedRows[rowIndex].observations) || 0;
        const impact = Number(updatedRows[rowIndex].impact) || 0;

        updatedRows[rowIndex].index = weight * observations * impact;

        setIndexRows(updatedRows);
    };

    const totalWeight = indexRows.reduce(
        (sum, row) => sum + (Number(row.weight) || 0),
        0
    );

    const totalIndex = indexRows.reduce(
        (sum, row) => sum + (Number(row.index) || 0),
        0
    );

    const calculatedGradeRows =
        gradeRows.map((row) => ({
            ...row,
            applicablePercentage:
                totalIndex > row.min && totalIndex < row.max
                    ? Number(row.percentage) * 100
                    : 0
        })) || [];

    const totalApplicablePercentage = calculatedGradeRows.reduce(
        (sum, row) => sum + (Number(row.applicablePercentage) || 0),
        0
    );

    const capitalChargeForShariahRisk = Math.round(
        (Number(operationalRiskCharge) || 0) *
        ((Number(totalApplicablePercentage) || 0) / 100)
    );

    const getQuarterSequence = (selectedQuarter) => {
        if (!selectedQuarter) return [];

        const [q, yearStr] = selectedQuarter.split("-");
        const year = Number(yearStr);
        const quarter = Number(q.replace("Q", ""));

        const quarters = [];

        for (let i = 3; i >= 0; i--) {
            let currentQuarter = quarter - i;
            let currentYear = year;

            while (currentQuarter <= 0) {
                currentQuarter += 4;
                currentYear--;
            }

            quarters.push(`Q${currentQuarter}-${currentYear}`);
        }

        return quarters;
    };

    const displayedQuarterHeaders = getQuarterSequence(reportingDate);

    const getQuarterFromDate = (date) => {
        const d = new Date(date);

        const year = d.getFullYear();
        const month = d.getMonth() + 1;

        if (month <= 3) return `Q1-${year}`;
        if (month <= 6) return `Q2-${year}`;
        if (month <= 9) return `Q3-${year}`;
        return `Q4-${year}`;
    };

    const dataMap = {};

    liveData.forEach(item => {
        const quarter = getQuarterFromDate(item.reporting_date);

        dataMap[`${item.key_areas}_${quarter}`] = item;
    });

    const getQuarterValues = (selectedQuarter, keyArea) => {

        const quarters = getQuarterSequence(selectedQuarter);

        return quarters.map(q => {

            const record = dataMap[`${keyArea}_${q}`];

            return record
                ? record.final_capital_charge_for_quarter4_average_of_4_quarters
                : "";
        });

    };

    // const sortQuarter = (a, b) => {

    //     const [qa, ya] = a.split("-");
    //     const [qb, yb] = b.split("-");

    //     const yearA = Number(ya);
    //     const yearB = Number(yb);

    //     if (yearA !== yearB) {
    //         return yearA - yearB;
    //     }

    //     return Number(qa.replace("Q", "")) - Number(qb.replace("Q", ""));
    // };

    const values = getQuarterValues(reportingDate, "Shariah Committee Matters");

    const q4 = capitalChargeForShariahRisk;

    const finalCapitalCharge = Math.round(
        (
            (Number(values[0]) || 0) +
            (Number(values[1]) || 0) +
            (Number(values[2]) || 0) +
            (Number(q4) || 0)
        ) / 4
    );

    const isSubmitEnabled =
        allowSubmit &&
        reportingDate !== "" &&
        operationalRiskCharge !== "" &&
        indexRows.every(
            row =>
                row.observations !== "" &&
                row.impact !== ""
        );

    const formatPercentTwoDecimal = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${Number(value).toFixed(2)}%`;
    };

    const formatPercent = (value) => {
        if (value === "" || value == null) return "0%";

        const num = Number(value);

        if (Number.isNaN(num)) return "0%";

        return `${(num * 100).toFixed(0)}%`;
    };

    // const formatExcelPercent = (value) => {
    //     if (value === "" || value == null) return "";

    //     return `${Number(value).toFixed(0)}%`;
    // };

    const formatExcelPercent = (value) => {
        if (value === "" || value == null) return "";

        return `${(Number(value) * 100).toFixed(0)}%`;
    };

    const formatApplicablePercent = (value) => {
        if (value === "" || value == null) return "0.00%";

        return `${Number(value).toFixed(2)}%`;
    };

    const formatIndex = (value) => {
        if (value === "" || value == null) return "";

        return Number(value).toLocaleString("en-US", {
            minimumFractionDigits: 1,
            maximumFractionDigits: 2,
        });
    };

    const formatNumber = (value) => {
        if (value === "\\N" || value === null || value === undefined || value === "") {
            return "";
        }

        const number = Number(value);

        if (isNaN(number)) {
            return value;
        }

        return number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    const handleReset = () => {
        // setReportingDate("");

        setOperationalRiskCharge("");
        setQ1("");
        setQ2("");
        setQ3("");

        setAllowSubmit(false);

        // Reset score dropdowns, descriptions and Average Score.
        setParameterScores({});

        const resetRows = indexRows.map((row) => ({
            ...row,
            observations: "",
            impact: "",
            index: 0,
        }));

        setIndexRows(resetRows);
    };

    // const getReportingDate = (quarter) => {
    //     if (!quarter) return "";

    //     const [q, year] = quarter.split("-");

    //     switch (q) {
    //         case "Q1":
    //             return `${year}-03-31`;
    //         case "Q2":
    //             return `${year}-06-30`;
    //         case "Q3":
    //             return `${year}-09-30`;
    //         case "Q4":
    //             return `${year}-12-31`;
    //         default:
    //             return "";
    //     }
    // };

    const generateTxtData = () => {
        const reportDate = getReportingDate(reportingDate);
        const lines = [];

        Object.values(parameterScores).forEach((item) => {
            lines.push([
                reportDate,
                item.score || "",
                item.description || "",
            ].join("|"));
        });

        return lines.join("\n");
    };

    const handleCloseReportingModal = () => {
        setselectedReportingDate1([]);
        setShowReportingModal(false);
    };

    useEffect(() => {

        if (selectedReportingDate1.length > 0) {
            handleReportingDateSubmit();
        } else {
            setCapitalChargeData([]);
        }

    }, [selectedReportingDate1]);

    const handleReportingDateSubmit = () => {

        const mergedData = [...liveData, ...tempData];

        const filteredData = mergedData.filter(item =>
            selectedReportingDate1.includes(
                getQuarterFromDate(item.reporting_date)
            )
        );

        const result = selectedReportingDate1
            .map(reportingDate => {

                const dateRows = filteredData.filter(
                    item =>
                        getQuarterFromDate(item.reporting_date) === reportingDate
                );

                if (dateRows.length === 0) {
                    return null;
                }

                const capitalChargeRow = dateRows.find(
                    item =>
                        item.final_capital_charge_for_quarter4_average_of_4_quarters &&
                        item.final_capital_charge_for_quarter4_average_of_4_quarters !== "\\N"
                );

                const rows = dateRows
                    .filter(item => item.key_areas)
                    .map(item => ({
                        key_areas:
                            item.key_areas === "\\N"
                                ? ""
                                : item.key_areas,

                        weight_a:
                            item.weight_a === "\\N"
                                ? ""
                                : item.weight_a,

                        observations:
                            item.no_of_observations_issues_non_compliance_delays_self_assesment_b === "\\N"
                                ? ""
                                : item.no_of_observations_issues_non_compliance_delays_self_assesment_b,

                        impact:
                            item.impact_scale_of_1_to_10_c === "\\N"
                                ? ""
                                : item.impact_scale_of_1_to_10_c
                    }));

                return {
                    reportingDate: reportingDate,

                    capitalCharge: capitalChargeRow
                        ? capitalChargeRow.final_capital_charge_for_quarter4_average_of_4_quarters
                        : "",

                    rows: rows
                };

            })
            .filter(Boolean);

        setCapitalChargeData(result);
    };

    const rejectColumns = [
        "reporting_date",
        "score",
        "Actual Value / Description"
    ];

    const handleBulkReject = () => {

        setSelectedColumn("");
        setOtherReason("");

        setShowRejectModal(true);
    };

    const handleColumnSelect = (e) => {

        setSelectedColumn(e.target.value);

        if (e.target.value !== "Others") {
            setOtherReason("");
        }
    };

    const handleOtherReasonChange = (e) => {
        setOtherReason(e.target.value);
    };

    const formatColumnLabel = (column) => {

        return column
            .replace(/_/g, " ")
            .replace(/\b\w/g, c => c.toUpperCase());

    };

    const isReasonRequired = selectedColumn === "Others";

    const isSubmitDisabled =
        !selectedColumn ||
        (isReasonRequired && !otherReason.trim());

    const handleReasonSubmit = () => {

        if (!selectedColumn) {

            setMessageType("warning");
            setModalMessage("Please select rejection reason.");
            setShowModal(true);

            return;
        }

        if (selectedColumn === "Others" && !otherReason.trim()) {

            setMessageType("warning");
            setModalMessage("Please enter rejection reason.");
            setShowModal(true);

            return;
        }

        let reason = "";

        if (selectedColumn === "DeleteRecord") {

            reason = otherReason.trim()
                ? otherReason.trim()
                : "Delete the record";

        }
        else if (selectedColumn === "Others") {

            reason = otherReason.trim();

        }
        else {

            reason = otherReason.trim()
                ? `${formatColumnLabel(selectedColumn)} is not correct : ${otherReason}`
                : `${formatColumnLabel(selectedColumn)} is not correct`;

        }

        setRejectedReason(reason);

        setShowRejectModal(false);

        callRejectApi(reason);

    };

    const createStatusJson = async (
        reportingDate,
        status,
        fileType,
        approvedRemarks = "",
        reason
    ) => {

        const today = new Date().toISOString().split("T")[0];
        const userId = localStorage.getItem("userid");

        const tableNameWithJson = `10192_reputational.json`;

        let statusData = [];

        try {
            const response = await fetch(`/jsonfiles/${tableNameWithJson}`);

            if (response.ok) {
                statusData = await response.json();
            }
        } catch (err) {
            console.log("No existing status file. Creating new one.");
        }

        const newStatus = {
            reporting_date: reportingDate,
            submitted_date: today,
            status,
            reported_by: "10192",
            reviewed_by: "10007",
            tableName: "reputational_thresholds"
        };

        if (approvedRemarks) {
            newStatus.approved_remarks = approvedRemarks;
        }


        if (reason) {
            newStatus.rejected_remarks = reason;
        }

        // Remove only the same reporting date
        const index = statusData.findIndex(
            item => item.reporting_date === reportingDate
        );

        if (index !== -1) {
            statusData.splice(index, 1);
        }

        // Latest entry always first
        statusData.unshift(newStatus);

        const updateResponse = await axios.post(
            updatetextfile3001,
            {
                tableNameWithJson,
                content: JSON.stringify(statusData, null, 2)
            },
            {
                headers: {
                    userId,
                    "x-csrf-token": csrfToken
                },
                withCredentials: true
            }
        );

        if (updateResponse.status === 200) {
            const fileName = "10192_reputational.json";
            const filePath = `/saswork/nas/${fileName}`;

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    dept: department,
                    Notifications: "IN",
                    filePath: filePath
                }
            };

            try {
                const response = await axios.post(
                    shariahremarks,
                    {},
                    config
                );

                console.log("Shariah Remarks API Response:", response.data);

            } catch (err) {
                console.error("Shariah Remarks API Error:", err);
            }
        }

        console.log(`${tableNameWithJson} updated successfully`);
    };

    const callRejectApi = async (reason) => {

        const reportDate = getReportingDate(reportingDate);

        const selectedRecords = tempData.filter(
            row => row.reporting_date === reportDate
        );

        const rowIds = selectedRecords.map(row => row.rowId);
        console.log("Row IDs:", rowIds);
        // console.log("First Row ID:", rowIds[0]);

        try {

            const config = {

                headers: {

                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,

                },

                withCredentials: true,

                params: {
                    // rowId: rowIds,
                    tableName: "reputational_thresholds",
                    status: 0,
                    dataModel: "BDM",
                    rejectedReason: reason,
                    "Notifications": "IN",
                    isBulk: 1,
                    dept: department

                }

            };

            const response = await axios.post(
                checkboxreject,
                rowIds,   // <-- Send row IDs in the request body
                config
            );

            console.log("Row IDs1:", rowIds);
            // console.log("First Row ID:", rowIds[0]);
            console.log(response.data);

            if (response.data?.message === "Data Rejected") {

                setMessageType("success");
                setModalMessage("Data Rejected Successfully");

                await createStatusJson(
                    reportDate,
                    "Pending for Maker Modification",
                    "reject",
                    "",
                    reason
                );

                await fetchPreviewData();

                setReportingDate("");
                setMakerRemarks("");
                handleReset();
                setIsViewMode(false);

                setShowDownload(false);   // <-- Hide download

            } else {

                setMessageType("error");
                setModalMessage(response.data.message || "Reject Failed");

            }

            setShowModal(true);
        }
        catch (error) {

            console.log(error);

            setMessageType("error");

            setModalMessage(

                error.response?.data?.message ||

                "Error while rejecting."

            );

            setShowModal(true);

        }

    };

    const handleBulkApprove = async () => {

        setShowConfirmApprove(false);

        const reportDate = getReportingDate(reportingDate);

        const selectedRecords = tempData.filter(
            row => row.reporting_date === reportDate
        );

        const rowIds = selectedRecords.map(row => row.rowId);

        try {

            const config = {
                headers: {
                    userId: localStorage.getItem("userid"),
                    "x-csrf-token": csrfToken,
                },
                withCredentials: true,
                params: {
                    tableName: "reputational_thresholds",
                    status: 1,
                    dataModel: "BDM",
                    Notifications: "IN",
                    isBulk: 1,
                    dept: department,
                },
            };

            const response = await axios.post(
                checkboxapprove,   // <-- Bulk approve checkbox API
                rowIds,            // <-- Send row IDs in request body
                config
            );

            console.log(response.data);

            if (response.data?.message === "Data Approved") {

                setMessageType("success");
                setModalMessage("Data Approved Successfully");

                await createStatusJson(
                    reportDate,
                    "Data Approved",
                    "approve",
                    inputValue
                );
                await fetchPreviewData();
                SetshowMakerremarks(false);

                // setShowDownload(true);   // <-- Show Download button
                setShowActionButtons(false);


            } else {

                setMessageType("error");
                setModalMessage(response.data.message || "Approval Failed");

            }

            setShowModal(true);

        } catch (error) {

            console.log(error);

            setMessageType("error");
            setModalMessage(
                error.response?.data?.message ||
                "Error while approving."
            );

            setShowModal(true);
        }
    };

    const handleCloseMakerPOP = () => {
        SetshowMakerremarks(false);
        setShowReportingModal1(false);
        setShowReportingModal(false);
        setShowChargeModal(false);
    };

    const getFinalCapitalLabel = (selectedQuarter) => {
        if (!selectedQuarter)
            return "Final Capital Charge (Average of 4 Quarters)";

        const [q, year] = selectedQuarter.split("-");

        const quarterEndDates = {
            Q1: `31-MAR-${year}`,
            Q2: `30-JUN-${year}`,
            Q3: `30-SEP-${year}`,
            Q4: `31-DEC-${year}`
        };

        return `Final Capital Charge for ${quarterEndDates[q]} (Average of 4 Quarters)`;
    };

    const headerRowIndex = excelRows.findIndex((row) =>
        row.some((cell) =>
            String(cell).trim().toLowerCase() === "parameters"
        )
    );

    const averageRowIndex = excelRows.findIndex((row) =>
        row.some((cell) =>
            String(cell).trim().toLowerCase() === "rating"
        )
    );

    // const excelTitle = excelRows
    //     .flat()
    //     .find(
    //         (cell) =>
    //             String(cell).trim().toLowerCase() ===
    //             "Customer and Stakeholder Complaints"
    //     );


    const normalizeThreshold = (value) =>
        String(value ?? "").trim().replace(/\s/g, "").toUpperCase();

    const isSpecialThreshold = (value) =>
        ["~%", "100%+"].includes(normalizeThreshold(value));

    const isValidThreshold = (value) => {
        const v = normalizeThreshold(value);

        // Allow temporary empty input while editing.
        if (v === "") return true;

        // Special threshold values.
        if (v === "~%" || v === "100%+") return true;

        // Numbers only, optionally followed by %.
        if (!/^\d+(?:\.\d*)?%?$/.test(v)) return false;

        const number = Number(v.replace("%", ""));

        return Number.isFinite(number) && number >= 0 && number <= 100;
    };

    const isValidScore = (value) =>
        /^\d*$/.test(String(value ?? "").trim());

    const getNextFromValue = (toValue) => {
        const value = normalizeThreshold(toValue);

        if (value === "100" || value === "100%") {
            return "100%+";
        }

        if (value === "100%+") {
            return "~%";
        }

        if (value === "~%") {
            return "~%";
        }

        const match = value.match(/^(\d+(?:\.\d*)?|\.\d+)%?$/);

        if (!match) return null;

        return `${Number(match[1])}%`;
    };

    const normalizeCustomerType = (value) =>
        String(value ?? "")
            .replace(/[\r\n]+/g, " ")
            .replace(/\s*-\s*/g, "-")
            .replace(/\s+/g, " ")
            .trim()
            .toLowerCase();

    const nonRetailStartRow = excelRows.findIndex((row) =>
        row.some(
            (cell) =>
                normalizeCustomerType(cell) === "non-retail customers"
        )
    );

    const retailAddedCount = newComplaintSections.filter(
        (section) =>
            normalizeCustomerType(section.customerType) === "retail customers"
    ).length;

    const averageScoreRows = [
        ...new Map(
            complaintApiData
                .filter(
                    (item) =>
                        item.SCORE != null ||
                        item.RATING != null ||
                        item.AVERAGE_SCORE != null
                )
                .map((item) => [
                    JSON.stringify([
                        item.SCORE,
                        item.RATING,
                        item.AVERAGE_SCORE,
                    ]),
                    {
                        section: item.SCORE ?? "",
                        rating: item.RATING ?? "",
                        averageScore: item.AVERAGE_SCORE ?? "",
                    },
                ])
        ).values(),
    ];

    return (
        <div
            className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}
            style={{
                backgroundImage: "none",
                backgroundColor: "#ffffff"
            }}
        >
            <Header />

            <Navigation />
            <main className="flex-grow-1 container-fluid" style={{ margin: 0, padding: 0, background: "none" }}>
                <div className={styles.mainContainer}>
                    <div className="container-fluid py-2">
                        <div className="row">
                            <div className="row">

                                {loading && (
                                    <div className="loading-overlay">
                                        <UploadLoadingIcon />
                                    </div>
                                )}

                                {!loading && excelRows.length === 0 ? (
                                    <div className="card">
                                        <div className="card-body text-center">
                                            No Data Found
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <div className="card-header bg-primary text-white">
                                            <h5 className="mb-0">
                                                {excelTitle}
                                            </h5>
                                        </div>

                                        <div
                                            style={{
                                                height: "calc(100vh - 220px)",
                                                minHeight: "300px",
                                                overflowY: "auto",
                                                overflowX: "auto",
                                                position: "relative",
                                            }}
                                        >
                                            <div
                                                className="row g-0 align-items-start"
                                                style={{ minWidth: "1100px", margin: 0 }}
                                            >
                                                {/* LEFT TABLE */}
                                                <div className="col-6">
                                                    <div className="h-100">
                                                        <div style={{ height: "40px", display: "flex", alignItems: "center" }}>
                                                            {modifiedOn && (
                                                                <div className="text-success fw-semibold">
                                                                    {excelTitle} Updated on {modifiedOn}
                                                                </div>
                                                            )}
                                                        </div>

                                                        <div style={{ padding: 0, margin: 0 }}>
                                                            {loading ? (
                                                                <div>Loading Excel...</div>
                                                            ) : complaintApiData.length === 0 ? (
                                                                <div className="text-center">No Data Found</div>
                                                            ) : (
                                                                <>
                                                                    <div style={{ width: "100%", overflow: "visible" }}>
                                                                        <div
                                                                            className="table-on-homepage-only"
                                                                            style={{ padding: 0, margin: 0 }}
                                                                        >
                                                                            <div style={{ padding: 0, margin: 0 }}>
                                                                                <table
                                                                                    ref={leftTableRef}
                                                                                    className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}
                                                                                    style={{ tableLayout: "fixed", width: "100%" }}
                                                                                >
                                                                                    {/* Dynamic Table Header */}
                                                                                    {headerRowIndex !== -1 && (
                                                                                        <thead className="thead-light">
                                                                                            <tr>
                                                                                                {excelRows[headerRowIndex].map((cell, colIndex) => {
                                                                                                    const merge = excelMerges.find(
                                                                                                        (m) =>
                                                                                                            m.s.r === headerRowIndex &&
                                                                                                            m.s.c === colIndex
                                                                                                    );

                                                                                                    const isMergedContinuation = excelMerges.some(
                                                                                                        (m) =>
                                                                                                            headerRowIndex >= m.s.r &&
                                                                                                            headerRowIndex <= m.e.r &&
                                                                                                            colIndex >= m.s.c &&
                                                                                                            colIndex <= m.e.c &&
                                                                                                            (headerRowIndex !== m.s.r ||
                                                                                                                colIndex !== m.s.c)
                                                                                                    );

                                                                                                    if (isMergedContinuation) {
                                                                                                        return null;
                                                                                                    }

                                                                                                    return (
                                                                                                        <th
                                                                                                            key={colIndex}
                                                                                                            rowSpan={
                                                                                                                merge
                                                                                                                    ? merge.e.r - merge.s.r + 1
                                                                                                                    : undefined
                                                                                                            }
                                                                                                            colSpan={
                                                                                                                merge
                                                                                                                    ? merge.e.c - merge.s.c + 1
                                                                                                                    : undefined
                                                                                                            }
                                                                                                            style={{
                                                                                                                verticalAlign: "middle",
                                                                                                                textAlign: "center",
                                                                                                                whiteSpace: "pre-line",
                                                                                                                fontWeight: "bold",
                                                                                                            }}
                                                                                                        >
                                                                                                            {cell}
                                                                                                        </th>
                                                                                                    );
                                                                                                })}
                                                                                            </tr>
                                                                                        </thead>
                                                                                    )}

                                                                                    <tbody>
                                                                                        {(() => {
                                                                                            // Group API rows by customer type, S.No. and parameter.
                                                                                            const groups = [];
                                                                                            const groupMap = new Map();

                                                                                            complaintApiData.forEach((item) => {
                                                                                                const key = JSON.stringify([
                                                                                                    item.CUSTOMER_TYPE ?? "",
                                                                                                    item.SR_NO ?? "",
                                                                                                    item.PARAMETERS ?? "",
                                                                                                ]);

                                                                                                if (!groupMap.has(key)) {
                                                                                                    const group = {
                                                                                                        key,
                                                                                                        customerType: item.CUSTOMER_TYPE ?? "",
                                                                                                        srNo: item.SR_NO ?? "",
                                                                                                        parameter: item.PARAMETERS ?? "",
                                                                                                        rows: [],
                                                                                                    };

                                                                                                    groupMap.set(key, group);
                                                                                                    groups.push(group);
                                                                                                }

                                                                                                groupMap.get(key).rows.push(item);
                                                                                            });

                                                                                            // Calculate how many rendered rows each customer type occupies.
                                                                                            const customerTypeCounts = new Map();

                                                                                            groups.forEach((group) => {
                                                                                                const count = group.rows.length + 1; // +1 for From/To/Score headings

                                                                                                customerTypeCounts.set(
                                                                                                    group.customerType,
                                                                                                    (customerTypeCounts.get(group.customerType) || 0) + count
                                                                                                );
                                                                                            });

                                                                                            const displayedCustomerTypes = new Set();

                                                                                            return groups.map((group) => {
                                                                                                const groupRowSpan = group.rows.length + 1;
                                                                                                const showCustomerType =
                                                                                                    !displayedCustomerTypes.has(group.customerType);

                                                                                                displayedCustomerTypes.add(group.customerType);

                                                                                                const cellStyle = {
                                                                                                    whiteSpace: "pre-line",
                                                                                                    overflowWrap: "break-word",
                                                                                                    verticalAlign: "middle",
                                                                                                    textAlign: "center",
                                                                                                };

                                                                                                return (
                                                                                                    <React.Fragment key={group.key}>
                                                                                                        {/* Heading row for this parameter */}
                                                                                                        <tr data-group-key={group.key}>
                                                                                                            {showCustomerType && (
                                                                                                                <td
                                                                                                                    rowSpan={customerTypeCounts.get(
                                                                                                                        group.customerType
                                                                                                                    )}
                                                                                                                    style={{
                                                                                                                        ...cellStyle,
                                                                                                                        fontWeight: "bold",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {group.customerType}
                                                                                                                </td>
                                                                                                            )}

                                                                                                            <td
                                                                                                                rowSpan={groupRowSpan}
                                                                                                                style={cellStyle}
                                                                                                            >
                                                                                                                {group.srNo}
                                                                                                            </td>

                                                                                                            <td
                                                                                                                rowSpan={groupRowSpan}
                                                                                                                style={{
                                                                                                                    ...cellStyle,
                                                                                                                    width: "35%",
                                                                                                                    maxWidth: "35%",
                                                                                                                    whiteSpace: "normal",
                                                                                                                    overflowWrap: "anywhere",
                                                                                                                    wordBreak: "break-word",
                                                                                                                    textAlign: "left",
                                                                                                                    verticalAlign: "middle",
                                                                                                                    fontWeight: "bold",
                                                                                                                }}
                                                                                                            >
                                                                                                                {group.parameter}
                                                                                                            </td>
                                                                                                            <td style={{ ...cellStyle, fontWeight: "bold" }}>
                                                                                                                From
                                                                                                            </td>

                                                                                                            <td style={{ ...cellStyle, fontWeight: "bold" }}>
                                                                                                                To
                                                                                                            </td>

                                                                                                            <td style={{ ...cellStyle, fontWeight: "bold" }}>
                                                                                                                Score
                                                                                                            </td>
                                                                                                        </tr>

                                                                                                        {/* Threshold values from the API */}
                                                                                                        {group.rows.map((item, index) => (
                                                                                                            <tr
                                                                                                                key={`${group.key}-${index}`}
                                                                                                                data-group-key={group.key}
                                                                                                            >
                                                                                                                <td style={cellStyle}>
                                                                                                                    {item.FROM_THRESHOLD ?? ""}
                                                                                                                </td>

                                                                                                                <td style={cellStyle}>
                                                                                                                    {item.TO_THRESHOLD ?? ""}
                                                                                                                </td>

                                                                                                                <td style={cellStyle}>
                                                                                                                    {item.SCORE_THRESHOLD ?? ""}
                                                                                                                </td>
                                                                                                            </tr>
                                                                                                        ))}
                                                                                                    </React.Fragment>
                                                                                                );
                                                                                            });
                                                                                        })()}
                                                                                    </tbody>


                                                                                </table>

                                                                            </div>



                                                                            {/* Table 2: Rating and Average Score */}

                                                                            <div
                                                                                style={{
                                                                                    display: "flex",
                                                                                    justifyContent: "center",
                                                                                    width: "100%",
                                                                                    padding: "16px",
                                                                                }}
                                                                            >
                                                                                {averageRowIndex !== -1 && (
                                                                                    <div
                                                                                        style={{
                                                                                            width: "60%",
                                                                                            maxWidth: "650px",
                                                                                            minWidth: "350px",
                                                                                            margin: "0 auto",
                                                                                        }}
                                                                                    >
                                                                                        <h5 className="text-center mb-3">Rating and Average Score</h5>

                                                                                        <table
                                                                                            className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}
                                                                                            style={{ display: "table", width: "100%", margin: "0 auto" }}
                                                                                        >
                                                                                            <thead className="thead-light">
                                                                                                <tr>
                                                                                                    <th>Section</th>
                                                                                                    <th>Rating</th>
                                                                                                    <th>Average Score</th>
                                                                                                </tr>
                                                                                            </thead>

                                                                                            <tbody>
                                                                                                {averageScoreRows.map((item, index) => {
                                                                                                    const ratingColor = savedRatingColors[index] ||
                                                                                                        RATING_COLORS_BY_INDEX[index] || NEW_RATING_COLOR;

                                                                                                    return (
                                                                                                        <tr key={`${item.section}-${index}`}>
                                                                                                            <td>{item.section}</td>

                                                                                                            <td>
                                                                                                                <div
                                                                                                                    style={{
                                                                                                                        backgroundColor: ratingColor,
                                                                                                                        color: "#000000",
                                                                                                                        fontWeight: 600,
                                                                                                                        padding: "8px",
                                                                                                                        borderRadius: "4px",
                                                                                                                        width: "100%",
                                                                                                                        boxSizing: "border-box",
                                                                                                                    }}
                                                                                                                >
                                                                                                                    {item.rating}
                                                                                                                </div>
                                                                                                            </td>

                                                                                                            <td>{item.averageScore}</td>
                                                                                                        </tr>
                                                                                                    );
                                                                                                })}
                                                                                            </tbody>
                                                                                        </table>
                                                                                    </div>
                                                                                )}
                                                                            </div>



                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* RIGHT SIDE: Score and Actual Value / Description */}
                                                <div className="col-6">
                                                    <div className="h-100">
                                                        <div style={{ padding: 0, margin: 0 }}>
                                                            <div style={{ width: "100%", overflow: "visible" }}>
                                                                <div className="table-on-homepage-only" style={{ padding: 0, margin: 0 }}>
                                                                    <div style={{ padding: 0, margin: 0 }}>
                                                                        {/* Reporting Date (same 40px height as the left top block) */}
                                                                        <div
                                                                            className="d-flex justify-content-end align-items-center flex-wrap gap-2"
                                                                            style={{ height: "40px" }}
                                                                        >
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <label
                                                                                    htmlFor="reportingDate"
                                                                                    className="fw-semibold mb-0 text-nowrap"
                                                                                >
                                                                                    Reporting Date
                                                                                </label>


                                                                                <input
                                                                                    id="reportingDate"
                                                                                    type="text"
                                                                                    className="form-control form-control-sm"
                                                                                    style={{ width: "150px" }}
                                                                                    value={reportingDate}
                                                                                    readOnly
                                                                                />
                                                                            </div>
                                                                            {!isNullValue(makerRemarks) && (
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <label className="fw-semibold mb-0 text-nowrap">
                                                                                        Remarks
                                                                                    </label>

                                                                                    <span
                                                                                        className="text-danger fw-semibold"
                                                                                        style={{
                                                                                            maxWidth: "350px",
                                                                                            wordBreak: "break-word"
                                                                                        }}
                                                                                    >
                                                                                        {makerRemarks}
                                                                                    </span>
                                                                                </div>
                                                                            )}
                                                                        </div>

                                                                        <table
                                                                            className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}
                                                                            style={{
                                                                                tableLayout: "fixed",
                                                                                width: "100%",
                                                                                marginBottom: 0,
                                                                            }}
                                                                        >
                                                                            <thead
                                                                                style={
                                                                                    theadHeight
                                                                                        ? { height: `${theadHeight}px` }
                                                                                        : undefined
                                                                                }
                                                                            >
                                                                                <tr>
                                                                                    <th
                                                                                        style={{
                                                                                            width: "33.33%",
                                                                                            textAlign: "center",
                                                                                            verticalAlign: "middle",
                                                                                        }}
                                                                                    >
                                                                                        Score Provided*
                                                                                    </th>

                                                                                    <th
                                                                                        style={{
                                                                                            width: "66.67%",
                                                                                            textAlign: "center",
                                                                                            verticalAlign: "middle",
                                                                                        }}
                                                                                    >
                                                                                        Actual Value / Description
                                                                                    </th>
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                {(() => {
                                                                                    const groupedParameters = new Map();

                                                                                    complaintApiData.forEach((item) => {
                                                                                        const key = JSON.stringify([
                                                                                            item.CUSTOMER_TYPE ?? "",
                                                                                            item.SR_NO ?? "",
                                                                                            item.PARAMETERS ?? "",
                                                                                        ]);

                                                                                        if (!groupedParameters.has(key)) {
                                                                                            groupedParameters.set(key, {
                                                                                                key,
                                                                                                customerType: item.CUSTOMER_TYPE ?? "",
                                                                                                srNo: item.SR_NO ?? "",
                                                                                                parameter: item.PARAMETERS ?? "",
                                                                                                rows: [],
                                                                                            });
                                                                                        }

                                                                                        groupedParameters.get(key).rows.push(item);
                                                                                    });

                                                                                    return Array.from(groupedParameters.values()).map((group) => {
                                                                                        const current =
                                                                                            parameterScores[group.key] || {
                                                                                                score: "",
                                                                                                description: "",
                                                                                            };

                                                                                        const scores = [
                                                                                            ...new Set(
                                                                                                group.rows
                                                                                                    .map((row) =>
                                                                                                        String(row.SCORE_THRESHOLD ?? "").trim()
                                                                                                    )
                                                                                                    .filter(
                                                                                                        (score) =>
                                                                                                            score !== "" &&
                                                                                                            !Number.isNaN(Number(score))
                                                                                                    )
                                                                                            ),
                                                                                        ];

                                                                                        // Use the REAL measured height of the left group.
                                                                                        // Falls back to an estimate until measured.
                                                                                        const matchingGroupHeight =
                                                                                            groupHeights[group.key] ??
                                                                                            (group.rows.length + 1) * 36;

                                                                                        return (
                                                                                            <tr
                                                                                                key={group.key}
                                                                                                style={{ height: `${matchingGroupHeight}px` }}
                                                                                            >
                                                                                                {/* Score */}
                                                                                                <td
                                                                                                    style={{
                                                                                                        width: "33.33%",
                                                                                                        padding: "4px",
                                                                                                        height: `${matchingGroupHeight}px`,
                                                                                                        textAlign: "center",
                                                                                                        verticalAlign: "middle",
                                                                                                    }}
                                                                                                >
                                                                                                    {/* <select
                                                                                                        className="form-select"
                                                                                                        style={{
                                                                                                            fontSize: "13px",
                                                                                                            padding: "4px 24px 4px 8px",
                                                                                                            lineHeight: "1.2",
                                                                                                            width: "100%",
                                                                                                        }}
                                                                                                        value={current.score}
                                                                                                        onChange={(e) =>
                                                                                                            setParameterScores((prev) => ({
                                                                                                                ...prev,
                                                                                                                [group.key]: {
                                                                                                                    ...(prev[group.key] || {
                                                                                                                        score: "",
                                                                                                                        description: "",
                                                                                                                    }),
                                                                                                                    score: e.target.value,
                                                                                                                },
                                                                                                            }))
                                                                                                        }
                                                                                                    >
                                                                                                        <option value="">Select score</option>

                                                                                                        {scores.map((score) => (
                                                                                                            <option key={score} value={score}>
                                                                                                                {score}
                                                                                                            </option>
                                                                                                        ))}
                                                                                                    </select> */}
                                                                                                    <span>{current.score || ""}</span>
                                                                                                </td>

                                                                                                {/* Actual Value / Description */}
                                                                                                <td
                                                                                                    style={{
                                                                                                        width: "66.67%",
                                                                                                        padding: "4px",
                                                                                                        height: `${matchingGroupHeight}px`,
                                                                                                        verticalAlign: "middle",
                                                                                                    }}
                                                                                                >
                                                                                                    {/* <textarea
                                                                                                        className="form-control"
                                                                                                        rows={1}
                                                                                                        style={{
                                                                                                            width: "100%",
                                                                                                            height: `${Math.max(
                                                                                                                matchingGroupHeight - 8,
                                                                                                                42
                                                                                                            )}px`,
                                                                                                            boxSizing: "border-box",
                                                                                                            resize: "none",
                                                                                                        }}
                                                                                                        value={current.description}
                                                                                                        placeholder="Enter actual value / description"
                                                                                                        onChange={(e) =>
                                                                                                            setParameterScores((prev) => ({
                                                                                                                ...prev,
                                                                                                                [group.key]: {
                                                                                                                    ...(prev[group.key] || {
                                                                                                                        score: "",
                                                                                                                        description: "",
                                                                                                                    }),
                                                                                                                    description: e.target.value,
                                                                                                                },
                                                                                                            }))
                                                                                                        }
                                                                                                    /> */}
                                                                                                    {current.description || ""}
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    });
                                                                                })()}
                                                                            </tbody>
                                                                        </table>


                                                                        {/* Average Score + matching Rating */}
                                                                        {(() => {
                                                                            const selectedScores = Object.values(parameterScores)
                                                                                .map((item) => item.score)
                                                                                .filter((score) => score !== "" && score != null)
                                                                                .map(Number)
                                                                                .filter(Number.isFinite);

                                                                            const averageScore =
                                                                                selectedScores.length > 0
                                                                                    ? (
                                                                                        selectedScores.reduce((total, score) => total + score, 0) /
                                                                                        selectedScores.length
                                                                                    ).toFixed(1)
                                                                                    : "—";

                                                                            const matchedRating =
                                                                                averageScore !== "—"
                                                                                    ? getRatingForAverage(averageScore)
                                                                                    : null;

                                                                            const normalizeRating = (value) =>
                                                                                String(value ?? "")
                                                                                    .trim()
                                                                                    .replace(/\s+/g, " ")
                                                                                    .toLowerCase();

                                                                            // Match the rating name against the first table.
                                                                            const matchingIndex = matchedRating
                                                                                ? averageScoreRows.findIndex(
                                                                                    (row) =>
                                                                                        normalizeRating(row.rating) ===
                                                                                        normalizeRating(matchedRating.item?.rating)
                                                                                )
                                                                                : -1;

                                                                            // const ratingColor =
                                                                            //     matchingIndex >= 0
                                                                            //         ? RATING_COLORS_BY_INDEX[matchingIndex] || NEW_RATING_COLOR
                                                                            //         : "transparent";

                                                                            const savedRatingColors = (() => {
                                                                                try {
                                                                                    return JSON.parse(
                                                                                        localStorage.getItem("ratingColors") || "[]"
                                                                                    );
                                                                                } catch {
                                                                                    return [];
                                                                                }
                                                                            })();

                                                                            const ratingColor =
                                                                                matchingIndex >= 0
                                                                                    ? savedRatingColors[matchingIndex] ||
                                                                                    RATING_COLORS_BY_INDEX[matchingIndex] ||
                                                                                    NEW_RATING_COLOR
                                                                                    : "transparent";

                                                                            // Apply the background to a DIV, exactly like the first table.
                                                                            const renderColoredValue = (value) => (
                                                                                <div
                                                                                    style={{
                                                                                        backgroundColor: ratingColor,
                                                                                        color: "#000000",
                                                                                        fontWeight: 600,
                                                                                        padding: "8px",
                                                                                        borderRadius: "4px",
                                                                                        width: "100%",
                                                                                        boxSizing: "border-box",
                                                                                    }}
                                                                                >
                                                                                    {value}
                                                                                </div>
                                                                            );

                                                                            return (
                                                                                <table
                                                                                    className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}
                                                                                    style={{
                                                                                        width: "100%",
                                                                                        tableLayout: "fixed",
                                                                                        marginTop: 0,
                                                                                    }}
                                                                                >
                                                                                    <tbody>
                                                                                        <tr>
                                                                                            <td
                                                                                                style={{
                                                                                                    width: "50%",
                                                                                                    fontWeight: "bold",
                                                                                                    verticalAlign: "middle",
                                                                                                }}
                                                                                            >
                                                                                                Average Score
                                                                                            </td>

                                                                                            <td style={{ width: "50%", verticalAlign: "middle" }}>
                                                                                                {renderColoredValue(averageScore)}
                                                                                            </td>
                                                                                        </tr>

                                                                                        <tr>
                                                                                            <td
                                                                                                style={{
                                                                                                    width: "50%",
                                                                                                    fontWeight: "bold",
                                                                                                    verticalAlign: "middle",
                                                                                                }}
                                                                                            >
                                                                                                Rating
                                                                                            </td>

                                                                                            <td style={{ width: "50%", verticalAlign: "middle" }}>
                                                                                                {/* {renderColoredValue(
                                                                                                    matchedRating?.item?.rating ?? "—"
                                                                                                )} */}
                                                                                                {(
                                                                                                    matchedRating?.item?.rating ?? "—"
                                                                                                )}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            );
                                                                        })()}



                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>


                                                        {/* </div> */}
                                                        {showActionButtons && (
                                                            <div
                                                                className="d-flex justify-content-end gap-2 p-3"
                                                                style={{
                                                                    backgroundColor: "#ffffff",
                                                                    position: "relative",
                                                                    zIndex: 1,
                                                                }}
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-light btn-sm custom-btn"
                                                                    data-toggle="tooltip"
                                                                    data-placement="Left"
                                                                    title="Click to Reject"
                                                                    style={{
                                                                        ...Rejectcolor,
                                                                        color: 'white',
                                                                        marginLeft: '10px'
                                                                    }}
                                                                    onClick={handleBulkReject}
                                                                >
                                                                    Reject
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-light btn-sm custom-btn"
                                                                    data-toggle="tooltip"
                                                                    data-placement="Left"
                                                                    title="Click to Approve"
                                                                    // disabled={!isSubmitEnabled || isViewMode}
                                                                    // onClick={() => setShowConfirmApprove(true)}
                                                                    onClick={() => {
                                                                        setInputValue("");
                                                                        SetshowMakerremarks(true);
                                                                    }}
                                                                    style={{
                                                                        ...Aprrovecolor,
                                                                        color: "white",
                                                                        // marginRight: "10px",
                                                                        // pointerEvents: isSubmitEnabled ? "auto" : "none",
                                                                    }}
                                                                >
                                                                    Approve
                                                                </button>




                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                            <Modal
                                show={showModal}
                                onHide={handleCancel}
                                style={{ marginTop: '12vh' }}
                            >
                                <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} fade show`} role="alert"
                                    style={{ marginBottom: '0', maxHeight: '80vh', overflowY: 'auto' }}>

                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green' }}>✅</span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                marginBottom: '0px',
                                                color: messageType === 'success' ? 'green' : 'red',
                                                fontSize: '14px',
                                                whiteSpace: 'pre-wrap' // optional, if you want to preserve spaces or indentation
                                            }}
                                            dangerouslySetInnerHTML={{
                                                __html: modalMessage.replace(/\n/g, '<br />')
                                            }}
                                        ></p>



                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close position-absolute top-0 end-0 m-2" style={{ fontSize: '10px' }}
                                        onClick={handleCancel}>
                                    </button>

                                </div>
                            </Modal>

                            <Modal
                                show={showChargeModal}
                                onHide={() => setShowChargeModal(false)}
                                centered
                                size="xl"
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>
                                        Select Reporting Date for Comparison
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body>

                                    {/* REPORTING DATE SELECTION */}

                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: '25px',
                                            alignItems: 'center',
                                            marginBottom: '5px',
                                            padding: '8px 0'
                                        }}
                                    >

                                        <strong>
                                            Reporting Date:
                                        </strong>

                                        {reportingDates1.map(date => (

                                            <Form.Check
                                                key={date}
                                                type="checkbox"
                                                label={date}
                                                checked={selectedReportingDate1.includes(date)}
                                                onChange={(e) => {

                                                    if (e.target.checked) {

                                                        setselectedReportingDate1(prev => [
                                                            ...prev,
                                                            date
                                                        ]);

                                                    } else {

                                                        setselectedReportingDate1(prev =>
                                                            prev.filter(item => item !== date)
                                                        );

                                                    }

                                                }}
                                            />

                                        ))}

                                    </div>

                                    {/* SHOW DATA ONLY AFTER SELECTION */}

                                    {selectedReportingDate1.length > 0 && (

                                        <div style={{ overflowX: 'auto' }}>

                                            <table
                                                className={`table table-bordered text-center ${tableStyles.customScrollTable}`}
                                                style={{
                                                    verticalAlign: 'middle',
                                                    // minWidth: '1000px'
                                                }}
                                            >

                                                <thead>

                                                    {/* =========================
        FIRST HEADER ROW
       ========================= */}
                                                    <tr>

                                                        {capitalChargeData.map((dateData, index) => (

                                                            <React.Fragment key={index}>

                                                                <th
                                                                    colSpan="4"
                                                                    style={{
                                                                        backgroundColor: '#366872',
                                                                        color: 'white',
                                                                        textAlign: 'center'
                                                                    }}
                                                                >
                                                                    Period: {dateData.reportingDate}
                                                                </th>

                                                                {/* Separator - spans BOTH header rows */}
                                                                {index < capitalChargeData.length - 1 && (
                                                                    <th
                                                                        rowSpan="2"
                                                                        style={{
                                                                            width: '20px',
                                                                            minWidth: '20px',
                                                                            padding: 0,
                                                                            border: 'none',
                                                                            backgroundColor: 'white'
                                                                        }}
                                                                    />
                                                                )}

                                                            </React.Fragment>

                                                        ))}

                                                    </tr>


                                                    {/* =========================
        SECOND HEADER ROW
       ========================= */}
                                                    <tr>

                                                        {capitalChargeData.map((dateData, index) => (

                                                            <React.Fragment key={index}>

                                                                {/* Key Areas */}
                                                                <th
                                                                    style={{
                                                                        backgroundColor: '#366872',
                                                                        color: 'white',
                                                                        fontSize: '12px'
                                                                    }}
                                                                >
                                                                    Key Areas
                                                                </th>

                                                                {/* Weight */}
                                                                <th
                                                                    style={{
                                                                        backgroundColor: '#366872',
                                                                        color: 'white',
                                                                        fontSize: '12px'
                                                                    }}
                                                                >
                                                                    Weight
                                                                </th>

                                                                {/* No. of Observations */}
                                                                <th
                                                                    style={{
                                                                        backgroundColor: '#366872',
                                                                        color: 'white',
                                                                        fontSize: '12px'
                                                                    }}
                                                                >
                                                                    No. of Observations
                                                                </th>

                                                                {/* Impact */}
                                                                <th
                                                                    style={{
                                                                        backgroundColor: '#366872',
                                                                        color: 'white',
                                                                        fontSize: '12px'
                                                                    }}
                                                                >
                                                                    Impact Scale
                                                                    <br />
                                                                    (1 to 10)
                                                                </th>

                                                                {/* DO NOT ADD SEPARATOR HERE */}
                                                                {/* The separator from the first row has rowSpan="2" */}

                                                            </React.Fragment>

                                                        ))}

                                                    </tr>

                                                </thead>

                                                <tbody>

                                                    {(() => {

                                                        // Find the maximum number of rows among all reporting dates
                                                        const maxRows = Math.max(
                                                            ...capitalChargeData.map(
                                                                dateData => dateData.rows?.length || 0
                                                            )
                                                        );

                                                        return Array.from({ length: maxRows }).map((_, rowIndex) => (

                                                            <tr key={rowIndex}>

                                                                {capitalChargeData.map((dateData, dateIndex) => {

                                                                    // Get row belonging ONLY to this reporting date
                                                                    const currentRow =
                                                                        dateData.rows?.[rowIndex];

                                                                    const displayValue = (value) => {
                                                                        return (
                                                                            value === "\\N" ||
                                                                            value === null ||
                                                                            value === undefined
                                                                        )
                                                                            ? ""
                                                                            : value;
                                                                    };

                                                                    return (

                                                                        <React.Fragment key={dateIndex}>

                                                                            {/* KEY AREA */}
                                                                            <td
                                                                                style={{
                                                                                    textAlign: 'left',
                                                                                    fontWeight: '500'
                                                                                }}
                                                                            >
                                                                                {displayValue(
                                                                                    currentRow?.key_areas
                                                                                )}
                                                                            </td>


                                                                            {/* WEIGHT */}
                                                                            <td>
                                                                                {displayValue(
                                                                                    currentRow?.weight_a
                                                                                )}
                                                                            </td>


                                                                            {/* OBSERVATIONS */}
                                                                            <td>
                                                                                {displayValue(
                                                                                    currentRow?.observations
                                                                                )}
                                                                            </td>


                                                                            {/* IMPACT */}
                                                                            <td>
                                                                                {displayValue(
                                                                                    currentRow?.impact
                                                                                )}
                                                                            </td>


                                                                            {/* SPACE BETWEEN REPORTING DATES */}
                                                                            {dateIndex < capitalChargeData.length - 1 && (
                                                                                <td
                                                                                    style={{
                                                                                        width: '20px',
                                                                                        minWidth: '20px',
                                                                                        padding: 0,
                                                                                        border: 'none',
                                                                                        backgroundColor: 'white'
                                                                                    }}
                                                                                />
                                                                            )}

                                                                        </React.Fragment>

                                                                    );

                                                                })}

                                                            </tr>

                                                        ));

                                                    })()}

                                                </tbody>


                                                {/* FINAL CAPITAL CHARGE */}

                                                <tfoot>

                                                    <tr>

                                                        {capitalChargeData.map((dateData, index) => (

                                                            <React.Fragment key={index}>

                                                                <th
                                                                    colSpan="3"
                                                                    style={{
                                                                        backgroundColor: '#366872',
                                                                        color: 'white',
                                                                        textAlign: 'right'
                                                                    }}
                                                                >
                                                                    Final Capital Charge (SAR 000's)
                                                                </th>

                                                                <td
                                                                    style={{
                                                                        fontWeight: 'bold'
                                                                    }}
                                                                >
                                                                    {formatNumber(dateData.capitalCharge)}
                                                                </td>

                                                                {/* Space after each reporting date */}
                                                                {index < capitalChargeData.length - 1 && (
                                                                    <td
                                                                        style={{
                                                                            width: '20px',
                                                                            minWidth: '20px',
                                                                            padding: 0,
                                                                            border: 'none',
                                                                            backgroundColor: 'white'
                                                                        }}
                                                                    />
                                                                )}

                                                            </React.Fragment>

                                                        ))}

                                                    </tr>

                                                </tfoot>

                                            </table>

                                        </div>

                                    )}

                                </Modal.Body>

                                <Modal.Footer style={{ borderTop: 'none' }}>

                                    <Button variant="btn btn-outline-secondary btn-sm mx-2" style={cancelButtonStyle}
                                        onClick={() => setShowChargeModal(false)}
                                    >
                                        Close
                                    </Button>

                                </Modal.Footer>

                            </Modal>


                            <Modal
                                show={showReportingModal}
                                onHide={handleCloseReportingModal}
                                centered
                                backdrop="static"
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>
                                        Select Reporting Date
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body>

                                    {reportingDates1.map(date => (

                                        <Form.Check
                                            key={date}
                                            type="checkbox"
                                            label={date}
                                            checked={selectedReportingDate1.includes(date)}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setselectedReportingDate1(prev => [...prev, date]);
                                                } else {
                                                    setselectedReportingDate1(prev =>
                                                        prev.filter(item => item !== date)
                                                    );
                                                }
                                            }}
                                        />

                                    ))}

                                </Modal.Body>

                                <Modal.Footer style={{ borderTop: 'none' }}>

                                    <Button variant="btn btn-outline-secondary btn-sm mx-2" style={cancelButtonStyle}
                                        onClick={handleCloseReportingModal}
                                    >
                                        Close
                                    </Button>

                                    <Button variant="btn btn-success btn-sm"
                                        style={
                                            submitButtonStyle
                                        }
                                        disabled={selectedReportingDate1.length === 0}
                                        onClick={handleReportingDateSubmit}
                                    >
                                        Submit
                                    </Button>

                                </Modal.Footer>

                            </Modal>

                            <Modal
                                show={showRejectModal}
                                onHide={() => setShowRejectModal(false)}
                                backdrop="static"
                                keyboard={false}
                                size="lg"
                                style={{ marginTop: '12vh' }}
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>Reason for Rejection</Modal.Title>
                                </Modal.Header>
                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    <div className="form-group">
                                        <label htmlFor="column-select" className="text-secondary">Select Reason</label>

                                        <select
                                            className="form-control"
                                            id="column-select"
                                            onChange={handleColumnSelect}
                                            value={selectedColumn}
                                        >
                                            <option value="">Select Reason</option>

                                            {rejectColumns
                                                .filter(column => column !== "Maker_Remarks")
                                                .map((column, index) => (
                                                    <option key={index} value={column}>
                                                        {formatColumnLabel(column)} is not correct
                                                    </option>
                                                ))}

                                            <option value="DeleteRecord">Delete the record</option>
                                            <option value="Others">Others</option>
                                        </select>

                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="other-reason" className="text-secondary">Reason Details</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="reason-input"
                                            id="other-reason"
                                            value={otherReason}
                                            onChange={handleOtherReasonChange}
                                            placeholder="Provide Reason here..."
                                            required={isReasonRequired}
                                        />
                                    </div>
                                </Modal.Body>
                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button
                                        variant="secondary"
                                        onClick={() => setShowRejectModal(false)}
                                        style={cancelButtonStyle}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="primary"
                                        onClick={handleReasonSubmit}
                                        disabled={isSubmitDisabled}

                                        style={
                                            ProceedButtonStyle
                                        }
                                    >
                                        Proceed
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            <Modal
                                show={showReportingModal}
                                onHide={() => {
                                    setShowReportingModal(false);
                                    setReportingDate("");
                                    setAllowSubmit(false);
                                }}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: "12vh" }}
                            >
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                    closeButton>
                                    <Modal.Title style={{ fontSize: '16px' }}>
                                        Reporting Date Validation
                                    </Modal.Title>
                                </Modal.Header>

                                <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                    {reportingMessage}
                                </Modal.Body>

                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button
                                        variant="Primary"
                                        style={
                                            submitButtonStyle
                                        }
                                        onClick={() => {
                                            setShowReportingModal(false);
                                            setReportingDate("");
                                            setAllowSubmit(false);
                                            restoreExcelValues();
                                        }}
                                    >
                                        OK
                                    </Button>
                                </Modal.Footer>
                            </Modal>
                            <Modal show={showmakerRemarks} onHide={handleCloseMakerPOP} centered backdrop="static" keyboard={false}>
                                <Modal.Header
                                    style={{
                                        backgroundColor: '#366872',
                                        color: 'white',
                                        padding: '0.5rem 1rem'
                                    }}
                                >
                                    <Modal.Title style={{ fontSize: '16px' }}>Remarks</Modal.Title>
                                </Modal.Header>

                                <Modal.Body className="text-break overflow-auto" style={{ padding: '0.75rem 1rem', fontSize: '14px', maxHeight: "60vh" }}>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter your remarks"
                                        value={inputValue}
                                        onChange={(e) => setInputValue(e.target.value)}
                                    />
                                </Modal.Body>

                                <Modal.Footer style={{ borderTop: 'none' }}>
                                    <Button variant="btn btn-outline-secondary btn-sm mx-2" style={cancelButtonStyle} onClick={handleCloseMakerPOP}>
                                        Close
                                    </Button>
                                    <Button variant="btn btn-success btn-sm mx-2" onClick={handleBulkApprove}>
                                        Submit
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                        </div>
                        {/* </div> */}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyReportReview;